import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import ImportForm from 'import/components/ImportForm';
import { createRoute } from 'lib/util';
const { Form } = Common;

class ImportFormView extends Component {
  static propTypes = {
    company: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
    subcompany: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
    file: PropTypes.shape({ id: PropTypes.string.isRequired, name: PropTypes.string.isRequired }),
    handleFileSelected: PropTypes.func.isRequired,
    handleFileRemove: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleValueChange: PropTypes.func.isRequired,
    handleHeaderChange: PropTypes.func.isRequired,
    module: PropTypes.string.isRequired,
    headersOpciones: PropTypes.array.isRequired,
    headersSelect: PropTypes.array.isRequired,
    isImporting: PropTypes.bool.isRequired,

    canAdd: PropTypes.bool,
    companyId: PropTypes.string.isRequired,
    subcompanyId: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    canAdd: false,
  };

  state = { isSubmitted: false, isValid: false };

  handleSubmit = ({ isValid }) =>
    this.setState({ isSubmitted: true }, () => this.props.handleSubmit({ isValid }));

  handleValidation = (errors) => this.setState({ isValid: Object.keys(errors).length === 0 });

  render = () => {
    // console.log(this.props)
    return (
      <Common.Wrapper fluid={true}>
        {/* <Common.Header title={this.props.t("import.title")} /> */}
        <div className="col-12">
          <Common.Portlet
            title={this.props.t('import.title') + ' > ' + this.props.t('import.form_subtitle')}
            icon={'upload'}
            button={
              <div className="btn-group pull-right">
                {this.props.canAdd && (
                  <Form.Link
                    to={createRoute(this.props.companyId, this.props.subcompanyId, 'import/add')}
                    className="btn btn-info"
                  >
                    {this.props.t('actions.add')}
                  </Form.Link>
                )}
              </div>
            }
          >
            <ImportForm
              company={this.props.company}
              subcompany={this.props.subcompany}
              file={this.props.file}
              headersOpciones={this.props.headersOpciones}
              headersSelect={this.props.headersSelect}
              handleFileSelected={this.props.handleFileSelected}
              handleFileRemove={this.props.handleFileRemove}
              handleValidation={this.handleValidation}
              handleSubmit={this.handleSubmit}
              handleHeaderChange={this.props.handleHeaderChange}
              handleValueChange={this.props.handleValueChange}
              module={this.props.module}
              isLoading={this.props.isImporting}
              isSubmitted={this.state.isSubmitted}
              values={{ file: this.props.file }}
            />
          </Common.Portlet>
        </div>
      </Common.Wrapper>
    );
  };
}

export default translate()(ImportFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/ImportFormView.js